export default function UserResume({ openModal, resume, lang }: any) {
  const data = resume?.[0];

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Resume" : "Resume"}<span className="text-red-500">*</span></h3>
        <button
          onClick={() => openModal("resume")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      <div className="space-y-4">
        {/* Resume File */}
        <div className="flex items-center justify-between">
          <span className="text-gray-600 font-medium">{lang === "id" ? "File Resume" : "Resume File"}</span>
          {data?.resumeUrl ? (
            <a
              href={data.resumeUrl}
              download
              target="_blank"
              rel="noreferrer"
              className="text-primary font-semibold hover:underline"
            >
              {lang === "id" ? "Unduh" : "Download"}
            </a>
          ) : (
            <span className="text-gray-400">{lang === "id" ? "Tidak Upload" : "Not uploaded"}</span>
          )}
        </div>

        {/* Portfolio Link */}
        <div className="flex items-center justify-between">
          <span className="text-gray-600 font-medium">{lang === "id" ? "Link Portfolio" : "Portfolio Link"}</span>
          {data?.portfolio ? (
            <a
              href={data.portfolio}
              target="_blank"
              rel="noreferrer"
              className="text-primary font-semibold hover:underline"
            >
              {lang === "id" ? "Kunjungi" : "Visit"}
            </a>
          ) : (
            <span className="text-gray-400">Not provided</span>
          )}
        </div>
      </div>
    </div>
  );
}
